import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const schema = z
  .object({
    minutes: z.number().min(1).max(1440),
    listSelectionType: z.enum(['existing', 'new']).optional(),
    listId: z.string().optional(),
    listName: z.string().optional(),
    newListName: z.string().optional(),
  })
  .refine((data) => {
    if (data.listSelectionType === 'new') {
      return !!data.newListName
    }

    return !!data.listId
  })

export type CreateOpenChatsListFormValues = z.infer<typeof schema>
export const createOpenChatsListFormResolver = zodResolver(schema)
